<template>
  <div class="condition-select">
    <el-select :value="value" @input="output" :disabled="disabled">
      <el-option
        v-for="(item, index) in conditionList"
        :key="index"
        :value="item.value"
        :label="item.label"
      ></el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: "condition-select",
  props: {
    value: [String, Array],
    control: Object
  },
  computed: {
    disabled() {
      return !this.control
    },
    conditionList() {
      if (!this.control) {
        return [{ value: "IS", label: "设为" }]
      }
      let options = [
        { value: "IS", label: "设为" },
        { value: "NULL", label: "清空" }
      ]
      if (this.control.oneFlag === false || ["number", "money"].includes(this.control._type)) {
        options = options.concat([
          { value: "ADD", label: "增加" },
          { value: "DEL", label: "减少" }
        ])
      }
      return options
    }
  },
  methods: {
    output(value) {
      this.$emit("input", value)
    }
  }
}
</script>

<style lang="scss">
.condition-select {
  .el-select {
    width: 58px;
    margin: 1px 0;
    .el-input__inner {
      border-color: white;
      padding-left: 0px;
      font-size: 13px;
    }

    .el-input.is-focus .el-input__inner {
      border-color: white !important;
    }
    .el-input.is-disabled .el-input__inner {
      background-color: white;
    }
  }
}
</style>
